import { Link } from "react-router-dom";
import { CircleCheck } from "lucide-react";
const S3_URL = import.meta.env.VITE_S3_URL;

export type CardReviewProps = {
  item: any;
  rewardText: any;
  handleOpenModal: (id: string) => void;
}

const CardReview = (props: CardReviewProps) => {
  return (
    <div
      className="flex gap-3 mt-2 overflow-hidden transition-shadow border-b pb-2"
    >
      <div className="w-full flex">
        <div className="w-10/12">
          <Link
            to={`/detailPage/${props.item.campaign_id}`}
            className="flex w-full"
          >
            <div className="w-24 h-24 flex-shrink-0 overflow-hidden rounded-lg">
              <img
                src={`${S3_URL}${props.item.thumbnail}`}
                alt={props.item.title}
                className="object-cover w-full h-full"
              />
            </div>

            <div className="pl-2 max-w-[calc(100%-7rem)] flex flex-col justify-between">
              <div>
                <h3 className="font-bold text-[13px] text-gray-800 line-clamp-1">
                  {props.item.title || "제목 없음"}
                </h3>
                <p className="text-[11px] pt-1 text-[#999999] line-clamp-2 w-full">
                  {props.rewardText || "설명 없음"}
                </p>
              </div>
              <div className="text-[8px] mt-2">

                {/* {props.item.reservation_status === "취소됨" &&
                              props.item.is_reservation === true && (
                                <p className="text-[10px] pt-1 truncate w-full text-red-500">
                                  예약: 취소됨
                                </p>
                              )}
                            {props.item.is_reservation === false && (
                              <p className="text-[10px] pt-1 truncate w-full text-green-500">
                                예약: 사용됨
                              </p>
                            )} */}

              </div>
            </div>
          </Link>
        </div>

        <div className="w-2/12 flex items-end justify-end">
          <button
            onClick={() => props.handleOpenModal(props.item)}
            type="button"
            className="flex items-center gap-1 rounded-full text-[8px] hover:bg-red-600 bg-[#8660B2] shadow-sm px-2 border transition-colors text-white font-medium"
          >
            <CircleCheck width={12} />
            리뷰등록
          </button>
        </div>
      </div>
    </div>
  );
};

export default CardReview;